<ng-template #loadingGeneral>
  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>
</ng-template>

<ng-container *ngIf="!loading else loadingGeneral">
  <mat-card appearance="outlined" fxLayout="column" [hidden]="hidden">
    <mat-card-header>
      <mat-card-title>{{contract?.title}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item>
          <p>
            <strong>Company</strong>
            {{contract?.company?.companyName}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Created by:</strong>
            {{contract?.createdBy?.firstName}} {{contract?.createdBy?.lastName}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Referent Email:</strong>
            {{contract?.contractReferent?.email}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Start Date:</strong>
            {{contract?.startDate | date:"dd/MM/yyyy"}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>End Date:</strong>
            {{contract?.endDate | date:"dd/MM/yyyy"}}
          </p>
        </mat-list-item>
        <mat-list-item *ngIf="contract?.status === contractStatus.extended && contract?.extendedEndDate">
          <p>
            <strong>Extended Date:</strong>
            {{contract?.extendedEndDate | date:"dd/MM/yyyy"}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Status:</strong>
            {{contract?.status! | splitCamelCase}}
          </p>
        </mat-list-item>
      </mat-list>

      <mat-dialog-actions fxLayoutAlign="end" fxLayoutGap="3%">

        <!--EDIT-->
        <button *awIsInRoleAndStatusForThisEntity="[
                {permission: 'admin', status: contractStatus.new, entity: contract},
                {permission: 'customer', status: contractStatus.new, entity: contract},
                {permission: 'customer', status: contractStatus.testbedAssociation, entity: contract},
                {permission: 'admin', status: contractStatus.ongoing, entity: contract},
                {permission: 'customer', status: contractStatus.ongoing, entity: contract},
                {permission: 'admin', status: contractStatus.extended, entity: contract},
                {permission: 'customer', status: contractStatus.extended, entity: contract}
              ]" [disabled]="disabled" mat-button color="primary" (click)="openEditDialog()">
          <mat-icon>edit</mat-icon>
          Edit
        </button>


        <!--CHANGE STATUS-->
        <button *awIsInRoleAndStatusForThisEntity="[
                  {permission: 'admin', status: contractStatus.new, entity: contract},
                  {permission: 'admin', status: contractStatus.approvalWaiting, entity: contract},
                  {permission: 'admin', status: contractStatus.testbedAssociation, entity: contract},
                  {permission: 'admin', status: contractStatus.boxesWaiting, entity: contract},
                  {permission: 'admin', status: contractStatus.ongoing, entity: contract},
                  {permission: 'admin', status: contractStatus.extended, entity: contract},
                  {permission: 'admin', status: contractStatus.expired, entity: contract},
                  {permission: 'customer', status: contractStatus.new, entity: contract},
                  {permission: 'customer', status: contractStatus.testbedAssociation, entity: contract},
                  {permission: 'logistic', status: contractStatus.closed, entity: contract},
                  {permission: 'logistic', status: contractStatus.damageReported, entity: contract}
                ]" mat-button color="primary" [disabled]="disabled"
          (click)="openStatusDialog()">
          <mat-icon>new_releases</mat-icon>
          Manage
        </button>

        <!--DELETE-->
        <button (click)="deleteContract()" *awIsInRoleAndStatusForThisEntity="[
                {permission: 'admin', status: contractStatus.new, entity: contract},
                {permission: 'customer', status: contractStatus.new, entity: contract},
                {permission: 'admin', status: contractStatus.approvalWaiting, entity: contract},
                {permission: 'customer', status: contractStatus.approvalWaiting, entity: contract}
              ]" [disabled]="disabled" mat-button>
          <mat-icon>delete</mat-icon>
          Delete contract
        </button>


      </mat-dialog-actions>
    </mat-card-content>
  </mat-card>
</ng-container>
